var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamibia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 39.9999C31.0459 39.9999 40.0002 31.0456 40.0002 19.9999C40.0002 8.95418 31.0459 -0.00012207 20.0002 -0.00012207C8.95455 -0.00012207 0.000244141 8.95418 0.000244141 19.9999C0.000244141 31.0456 8.95455 39.9999 20.0002 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85786 34.1421C6.69684 34.9811 7.592 35.7293 8.53098 36.3881L36.3879 8.53105C35.7293 7.59206 34.9811 6.6969 34.142 5.85792C33.303 5.01894 32.4079 4.27081 31.4689 3.61206L3.612 31.4691C4.27067 32.4079 5.01887 33.3032 5.85786 34.1421V34.1421Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85793 5.8578C-0.45176 12.1675 -1.66301 21.6434 2.2216 29.1701L29.1702 2.22163C21.6435 -1.66298 12.1675 -0.451576 5.85793 5.8578V5.8578Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1421 34.1422C40.4516 27.8326 41.6629 18.3566 37.7784 10.8298L10.8298 37.7784C18.3565 41.663 27.8325 40.4518 34.1421 34.1422Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5217 11.3043L14.2806 12.3585L15.474 14.5289L13.0405 14.0635L12.732 16.5217L11.037 14.7136L9.34196 16.5217L9.03368 14.0635L6.60009 14.5289L7.79345 12.3584L5.55243 11.3043L7.79352 10.2501L6.60009 8.0798L9.0336 8.54527L9.34204 6.08691L11.037 7.89504L12.7321 6.08691L13.0405 8.54527L15.474 8.0798L14.2807 10.2502L16.5217 11.3043Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamibia);
export default __webpack_public_path__ + "static/media/namibia.0f130201ca186ab93809f6af29aaa36a.svg";
export { ForwardRef as ReactComponent };